import { create } from 'zustand';
import { TemplateStore } from './types';


export const useTemplateStore = create<TemplateStore>((set) => ({
  pageState: '',
  setPageState: (newState) => set({ pageState: newState }),
}));

